import * as React from 'react'

const NavigationDownArrow = ({
  title,
  titleId,
  ...props
}: {
  title?: string
  titleId?: string
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="#400099"
    focusable={false}
    aria-hidden
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M20.707 12.293a.999.999 0 00-1.414 0L13 18.586V3a1 1 0 00-2 0v15.586l-6.293-6.293a.999.999 0 10-1.414 1.414l8 8a.997.997 0 001.414 0l8-8a.999.999 0 000-1.414z" />
  </svg>
)

export default NavigationDownArrow
